<template>
    <el-row :gutter="10" style="padding: 0 20px">
        <el-col :span="3">
            <el-card class="box-card">
                <template #header>
                    <div class="card-header">
                        <span>所属模块</span>
                    </div>
                </template>
                <ul>
                    <li
                        v-for="item in modList"
                        :key="item.id"
                        :class="item.id == modId ? 'active' : ''"
                        @click="changeMod(item.id)"
                    >
                        {{ item.name }}
                    </li>
                </ul>
            </el-card>
        </el-col>
        <el-col :span="7">
            <el-card class="box-card" style="padding: 0 20px">
                <template #header>
                    <div class="card-header">
                        <span>缓存列表</span>
                    </div>
                </template>
                <el-table :data="cacheData" style="width: 100%" @row-click="rowClick">
                    <el-table-column type="index" label="序号" width="60" />
                    <el-table-column prop="cache_name" label="缓存名称" width="180" />
                    <el-table-column prop="remark" label="备注" />
                    <el-table-column label="操作" width="60">
                        <template #default="{ row }">
                            <el-button
                                type="primary"
                                link
                                :icon="Delete"
                                size="small"
                                @click="delCacheFun(row.cache_name)"
                            ></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </el-col>
        <el-col :span="7">
            <el-card class="box-card">
                <template #header>
                    <div class="card-header">
                        <span>键名列表</span>
                    </div>
                </template>
                <el-table :data="cacheKeyData" style="width: 100%" @row-click="rowKeyClick">
                    <el-table-column type="index" label="序号" width="60" />
                    <el-table-column label="缓存键名" show-overflow-tooltip>
                        <template #default="{ $index }">
                            {{ cacheKeyData[$index] }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="60">
                        <template #default="{ $index }">
                            <el-button
                                type="primary"
                                link
                                :icon="Delete"
                                size="small"
                                @click="delCacheKey(cacheKeyData[$index])"
                            ></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </el-col>
        <el-col :span="7">
            <el-card class="box-card">
                <template #header>
                    <div class="card-header">
                        <span>缓存内容</span>
                        <el-button type="primary" class="button" :icon="RefreshLeft" text @click="clearAll">清理全部</el-button>
                    </div>
                </template>
                <el-form :model="cacheInfo" style="padding: 0 20px" label-position="top">
                    <el-form-item label="缓存名称" prop="cache_name">
                        <el-input v-model="cacheInfo.cache_name" readonly />
                    </el-form-item>
                    <el-form-item label="缓存键名" prop="cache_key">
                        <el-input v-model="cacheInfo.cache_key" readonly />
                    </el-form-item>
                    <el-form-item label="缓存内容" prop="cache_value">
                        <el-input type="textarea" :rows="8" readonly v-model="cacheInfo.cache_value" />
                    </el-form-item>
                </el-form>
            </el-card>
        </el-col>
    </el-row>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { getModuleOptionLists } from '@/api/module'
import { delAllCache, delCache, delKey, getCacheKeyList, getCacheList, getCacheValue } from '@/api/monitor'
import { Delete, RefreshLeft } from '@element-plus/icons'
import { ElMessage, ElMessageBox } from 'element-plus'

const modList = ref([])
const modId = ref('')
const changeMod = (id) => {
    modId.value = id
    getCacheListFun(id)
}

const cacheData = ref([])
const getCacheListFun = async (id) => {
    cacheData.value = await getCacheList(id)
}
const cacheKeyData = ref([])

const currentCacheNAme = ref('')
const rowClick = async (row, column, event) => {
    if (column.label === '操作') return
    currentCacheNAme.value = row.cache_name
    cacheKeyData.value = await getCacheKeyList(row.cache_name)
}

const cacheInfo = ref({
    cache_name: '',
    cache_key: '',
    cache_value: null
})
const rowKeyClick = async (row, column, event) => {
    console.log(row, column, event, 'row, column, event')
    if (column.label === '操作') return
    cacheInfo.value = await getCacheValue(currentCacheNAme.value, row)
}
const delCacheFun = async (cname) => {
    await delCache(cname)
    ElMessage.success('删除成功')
    if (cname === currentCacheNAme.value) {
        cacheKeyData.value = await getCacheKeyList(cname)
        Object.keys(cacheInfo.value).forEach((ele) => {
            cacheInfo.value[ele] = ''
        })
    }
}

const delCacheKey = async (key) => {
    await delKey(key)
    ElMessage.success('删除成功')
    cacheKeyData.value = await getCacheKeyList(currentCacheNAme.value)
}

const clearAll = async () => {
    ElMessageBox.confirm('是否确认清空所有缓存内容?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            await delAllCache()
            cacheData.value = []
            cacheKeyData.value = []
            Object.keys(cacheInfo.value).forEach((ele) => {
                cacheInfo.value[ele] = ''
            })
            getCacheListFun(modId.value)
        })
        .catch(() => {})
}

onMounted(async () => {
    modList.value = await getModuleOptionLists()
})
</script>
<style scoped lang="scss">
:deep(.el-card__body) {
    padding: 20px 0;
}

:deep(.el-card) {
    height: calc(100vh - 125px);

    .el-card__header {
        padding: 10px;
    }
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

ul {
    list-style: none;

    li {
        padding: 10px 10px;
        box-sizing: border-box;
        cursor: pointer;

        &:hover:not(.active) {
            background-color: var(--el-color-primary-light-7);
        }
    }

    .active {
        background-color: #4291f7;
        color: #ffffff;
    }
}
:deep(.cell) {
    cursor: pointer;
}
</style>
